import { useState } from "react";
import MainLayout from "../layout";
import Page from "../page/Page";
import { useTranslation } from "react-i18next";
import { SliderHorizontalIcon } from "../utils/svg";
import { Section } from "@vshp/ui-components";
import i18n from "i18next";

function ProgramDirectors() {
  const { t } = useTranslation();
  const [backdropToggled, setBackdropToggled] = useState(true);
  let locale = i18n.language;

  let title = {
    caption: t("pages.program_directors.title"),
  };

  const handleBackdropClick = (e) => {
    setBackdropToggled(false);
  };

  return (
    <MainLayout title={title}>
      <Page title={t("pages.program_directors.title")} titleKey="pages.program_directors.title">
        <Section>
          <div className="stat__table">
            {backdropToggled && (
              <>
                <div className="stat__table-icon">
                  <SliderHorizontalIcon />
                </div>
                <div className="stat__table-backdrop" onClick={handleBackdropClick}></div>
              </>
            )}

            <div className="stat__table-data">
              <div className="stat__table-data-container">
                {locale !== "ru" ? (
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="4">
                          <strong>Faculty of Management</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Dean</strong>
                        </td>
                        <td> Daria Rozhkova </td>
                        <td> Associate Professor </td>
                        <td> d.rozhkova@siil.ch </td>
                      </tr>

                      <tr>
                        <td colSpan="4">
                          <strong>Study Programme Directors</strong>
                        </td>
                      </tr>
                      <tr>
                        <td> Bachelor in Event Management</td>
                        <td> Andrey Ilyin </td>
                        <td> Professor </td>
                        <td> a.ilyin@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Bachelor in Project Management</td>
                        <td> Daria Rozhkova </td>
                        <td> Associate Professor </td>
                        <td> d.rozhkova@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Bachelor in Luxury Brand Management</td>
                        <td> Nika Almar </td>
                        <td> Associate Professor </td>
                        <td> n.almar@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Master in International Relations</td>
                        <td> Yury Ovseenko </td>
                        <td> Professor </td>
                        <td>y.ovseenko@siil.ch</td>
                      </tr>
                      <tr>
                        <td> MBA RU </td>
                        <td> Sergei Bogachev </td>
                        <td> Professor </td>
                        <td> s.bogachev@siil.ch </td>
                      </tr>
                      <tr>
                        <td> MBA EN </td>
                        <td> Tatiana Zarubina </td>
                        <td> Professor </td>
                        <td> t.zarubina@siil.ch </td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="4">
                          <strong>Факультет менеджмента</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Декан факультета</strong>
                        </td>
                        <td> Дарья Рожкова</td>
                        <td> Доцент </td>
                        <td> d.rozhkova@siil.ch </td>
                      </tr>
                      <tr>
                        <td colSpan="4">
                          <strong>Директора учебных программ </strong>
                        </td>
                      </tr>
                      <tr>
                        <td> Бакалавриат «Event-менеджмент» </td>
                        <td> Андрей Ильин </td>
                        <td> Профессор </td>
                        <td> a.ilyin@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Бакалавриат «Проектный менеджмент» </td>
                        <td> Дарья Рожкова </td>
                        <td> Доцент </td>
                        <td> d.rozhkova@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Бакалавриат «Бренд-менеджмент товаров и услуг класса люкс»</td>
                        <td> Ника Алмар </td>
                        <td> Доцент </td>
                        <td> n.almar@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Магистратура «Магистр международных отношений»</td>
                        <td> Юрий Овсеенко</td>
                        <td> Профессор </td>
                        <td>y.ovseenko@siil.ch</td>
                      </tr>
                      <tr>
                        <td> Магистратура «Магистр делового администрирования»</td>
                        <td> Сергей Богачев </td>
                        <td> Профессор </td>
                        <td> s.bogachev@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Магистратура «Магистр делового администрирования в управлении бизнесом» - на английском</td>
                        <td> Татьяна Зарубина </td>
                        <td> Профессор </td>
                        <td> t.zarubina@siil.ch </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </Section>
        <Section>
          <div className="stat__table">
            {backdropToggled && (
              <>
                <div className="stat__table-icon">
                  <SliderHorizontalIcon />
                </div>
                <div className="stat__table-backdrop" onClick={handleBackdropClick}></div>
              </>
            )}

            <div className="stat__table-data">
              <div className="stat__table-data-container">
                {locale !== "ru" ? (
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="4">IT Faculty</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Dean</strong>
                        </td>
                        <td> Pavel Tkachev</td>
                        <td> Associate Professor </td>
                        <td> p.tkachev@siil.ch</td>
                      </tr>
                      <tr>
                        <td colSpan="4">
                          <strong>Study Programme Directors</strong>
                        </td>
                      </tr>
                      <tr>
                        <td> Bachelor in Information Systems and Technology</td>
                        <td>Pavel Tkachev</td>
                        <td>Associate Professor</td>
                        <td> p.tkachev@siil.ch</td>
                      </tr>
                      <tr>
                        <td> Bachelor’s Degree in Information Technology, Artificial Intelligence, and Machine Learning </td>
                        <td>Andrey Zaikov</td>
                        <td>Lecturer</td>
                        <td>a.zyikov@siil.ch</td>
                      </tr>
                      <tr>
                        <td> Bachelor in Internet Marketing</td>
                        <td>Anastasia Kashirina</td>
                        <td>Associate Professor</td>
                        <td> a.kashirina@siil.ch</td>
                      </tr>
                      <tr>
                        <td>Bachelor in Web Design</td>
                        <td>Polina Zakharova </td>
                        <td></td>
                        <td> p.zakharova@siil.ch</td>
                      </tr>
                      <tr>
                        <td>Master’s Degree in Artificial Intelligence and Machine Learning</td>
                        <td>Alexander Malyzhenkov</td>
                        <td>Associate Professor</td>
                        <td> a.malyzhenkov@siil.ch</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="4">Факультет информационных систем и технологий</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Декан факультета</strong>
                        </td>
                        <td> Павел Ткачев </td>
                        <td> Доцент </td>
                        <td> p.tkachev@siil.ch </td>
                      </tr>
                      <tr>
                        <td colSpan="4">
                          <strong>Директора учебных программ </strong>
                        </td>
                      </tr>

                      <tr>
                        <td> Бакалавриат «Информационные системы и технологии» </td>
                        <td> Павел Ткачев </td>
                        <td> Доцент </td>
                        <td> p.tkachev@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Бакалавр "Информационные технологии, искусственный интеллект и машинное обучение" </td>
                        <td> Андрей Зайков </td>
                        <td> Преподаватель </td>
                        <td> a.zyikov@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Бакалавриат «Интернет-маркетинг» </td>
                        <td> Анастасия Каширина </td>
                        <td> Доцент </td>
                        <td> a.kashirina@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Бакалавриат «Веб-дизайн» </td>
                        <td> Полина Захарова </td>
                        <td> Преподаватель </td>
                        <td>p.zakharova@siil.ch </td>
                      </tr>
                      <tr>
                        <td> Магистратура "Искусственный интеллект и машинное обучение" </td>
                        <td> Александр Малыженков </td>
                        <td> Доцент </td>
                        <td> a.malyzhenkov@siil.ch </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </Section>

        <Section>
          <div className="stat__table">
            {backdropToggled && (
              <>
                <div className="stat__table-icon">
                  <SliderHorizontalIcon />
                </div>
                <div className="stat__table-backdrop" onClick={handleBackdropClick}></div>
              </>
            )}

            <div className="stat__table-data">
              <div className="stat__table-data-container">
                {locale !== "ru" ? (
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="4">Faculty of Physics</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Dean</strong>
                        </td>
                        <td> Alexander Malyzhenkov</td>
                        <td> Associate Professor </td>
                        <td> a.malyzhenkov@siil.ch</td>
                      </tr>
                      <tr>
                        <td colSpan="4">
                          <strong>Study Programme Directors</strong>
                        </td>
                      </tr>
                      <tr>
                        <td> Bachelor’s Degree in Physics </td>
                        <td> Alexander Malyzhenkov</td>
                        <td> Associate Professor </td>
                        <td> a.malyzhenkov@siil.ch</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="4">Факультет физики</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Декан факультета</strong>
                        </td>
                        <td> Александр Малыженков </td>
                        <td> Доцент </td>
                        <td> a.malyzhenkov@siil.ch </td>
                      </tr>
                      <tr>
                        <td colSpan="4">
                          <strong>Директора учебных программ </strong>
                        </td>
                      </tr>

                      <tr>
                        <td> Бакалавриат "Физика" </td>
                        <td> Александр Малыженков </td>
                        <td> Доцент </td>
                        <td> a.malyzhenkov@siil.ch </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </Section>

        <Section>
          <div className="stat__table">
            {backdropToggled && (
              <>
                <div className="stat__table-icon">
                  <SliderHorizontalIcon />
                </div>
                <div className="stat__table-backdrop" onClick={handleBackdropClick}></div>
              </>
            )}

            <div className="stat__table-data">
              <div className="stat__table-data-container">
                {locale !== "ru" ? (
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="4">Faculty of Psychology</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Dean</strong>
                        </td>
                        <td> Kateryna Giroud</td>
                        <td> Professor </td>
                        <td> k.giroud@siil.ch</td>
                      </tr>
                      <tr>
                        <td colSpan="4">
                          <strong>Study Programme Directors</strong>
                        </td>
                      </tr>
                      <tr>
                        <td> Faculty of Psychology </td>
                        <td> Tatiana Tangisheva</td>
                        <td> Associate Professor </td>
                        <td>t.tangisheva@siil.ch</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="4">Факультет психологии</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Декан факультета</strong>
                        </td>
                        <td> Катерина Жеру </td>
                        <td> Профессор </td>
                        <td> k.giroud@siil.ch </td>
                      </tr>
                      <tr>
                        <td colSpan="4">
                          <strong>Директора учебных программ </strong>
                        </td>
                      </tr>

                      <tr>
                        <td> Бакалавриат "Психология" </td>
                        <td> Татьяна Тангишева </td>
                        <td> Доцент </td>
                        <td> t.tangisheva@siil.ch </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </Section>
      </Page>
    </MainLayout>
  );
}

export default ProgramDirectors;
